import { InitialETADuration, TimeOnSiteDuration } from "api/consts";
import {
  initialETAOptions,
  initialETAOptionsShippers,
} from "pages/inventoryview/utils/consts";

import Colors from "styles/colors";

export const pieChartDataByTimeOnSite = [
  {
    key: "days10_inf",
    vins_associated: 0,
    name: "10+ Days",
    fill: Colors.inventoryView.RED,
    searchOption: TimeOnSiteDuration.DAYS_10,
  },
  {
    key: "days6_9",
    vins_associated: 0,
    name: "6-9 Days",
    fill: Colors.inventoryView.ORANGE,
    searchOption: TimeOnSiteDuration.DAYS_6_9,
  },
  {
    key: "days3_5",
    vins_associated: 0,
    name: "3-5 Days",
    fill: Colors.inventoryView.ORANGE_YELLOW,
    searchOption: TimeOnSiteDuration.DAYS_3_5,
  },
  {
    key: "days0_2",
    vins_associated: 0,
    name: "0-2 Days",
    fill: Colors.inventoryView.GREEN,
    searchOption: TimeOnSiteDuration.DAYS_0_2,
  },
];

export const pieChartDataByEta = [
  {
    key: "hoursPast72",
    name: "72+ Hours Past ETA",
    fill: Colors.inventoryView.initialETA.BEYOND_PAST_72_HOURS,
    searchOption:
      initialETAOptionsShippers[InitialETADuration.BEYOND_PAST_72_HOURS],
  },
  {
    key: "hoursPast72_1",
    name: "1-72 Hours Past ETA",
    fill: Colors.inventoryView.initialETA.WITHIN_PAST_72_HOURS,
    searchOption:
      initialETAOptionsShippers[InitialETADuration.WITHIN_PAST_72_HOURS],
  },
  {
    key: "hours0_47",
    name: "0-47 Hours Out",
    fill: Colors.inventoryView.YELLOW,
    searchOption: initialETAOptionsShippers[InitialETADuration.HOURS_0_47_OUT],
  },
  {
    key: "hours48_95",
    name: "48-95 Hours Out",
    fill: Colors.inventoryView.ORANGE,
    searchOption: initialETAOptionsShippers[InitialETADuration.HOURS_48_95_OUT],
  },
  {
    key: "hours96_inf",
    name: "96+ Hours Out",
    fill: Colors.inventoryView.initialETA.HOURS_96_PLUS_OUT,
    searchOption: initialETAOptionsShippers[InitialETADuration.HOURS_96_OUT],
  },
];

export const pieChartDataByInitialEta = [
  {
    key: "hoursPast72",
    name: "72+ Hours Past ETA",
    fill: Colors.inventoryView.initialETA.BEYOND_PAST_72_HOURS,
    searchOption:
      initialETAOptionsShippers[InitialETADuration.BEYOND_PAST_72_HOURS],
  },
  {
    key: "hoursPast72_1",
    name: "1-72 Hours Past ETA",
    fill: Colors.inventoryView.initialETA.WITHIN_PAST_72_HOURS,
    searchOption:
      initialETAOptionsShippers[InitialETADuration.WITHIN_PAST_72_HOURS],
  },
  {
    key: "hoursOut0_47",
    name: "0-47 Hours Out",
    fill: Colors.inventoryView.YELLOW,
    searchOption: initialETAOptionsShippers[InitialETADuration.HOURS_0_47_OUT],
  },
  {
    key: "hoursOut48_95",
    name: "48-95 Hours Out",
    fill: Colors.inventoryView.ORANGE,
    searchOption: initialETAOptionsShippers[InitialETADuration.HOURS_48_95_OUT],
  },
  {
    key: "hoursOut96",
    name: "96+ Hours Out",
    fill: Colors.inventoryView.initialETA.HOURS_96_PLUS_OUT,
    searchOption: initialETAOptionsShippers[InitialETADuration.HOURS_96_OUT],
  },
];

export const pieChartDataByType = [
  Colors.graphs.CHART_BLUE,
  Colors.text.HIT_GRAY,
  Colors.graphs.CHART_GRAY,
];

export const pieChartDataByGateThreshold = [
  {
    key: "daysAgo150",
    name: "150+ Days ago",
    fill: Colors.inventoryView.initialETA.WITHIN_PAST_72_HOURS,
    searchOption: "daysAgo150",
  },
  {
    key: "daysAgo100_149",
    name: "100-149 Days ago",
    fill: Colors.inventoryView.YELLOW,
    searchOption: "daysAgo100_149",
  },
  {
    key: "daysAgo50_99",
    name: "50-99 Days ago",
    fill: Colors.inventoryView.ORANGE,
    searchOption: "daysAgo50_99",
  },
  {
    key: "daysAgo0_49",
    name: "0-49 Days ago",
    fill: Colors.inventoryView.GREEN,
    searchOption: "daysAgo0_49",
  },
];
